import { useEffect } from "react";
import { useSelector } from "react-redux";
import { BsFileEarmarkSpreadsheet } from "../../../assets/icons/vander";
import { useDashboardStore } from "../../../hooks";
import { LoadingData, ErrorMessage } from "../../ui";

export const NumberOfPatientSurgeriesChart = () => {
  // Datos del hook ----------------------------------------//
  const { isLoading, data, errorMessage } = useSelector(
    (state) => state.dashboard.numberOfPatientSurgeries
  );

  const { getDataNumberOf } = useDashboardStore();

  // States ------------------------------------------------//
  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  // Efectos -----------------------------------------------//
  useEffect(() => {
    // console.log("data:", data);
    if (!data) {
      getDataNumberOf("numberOfPatientSurgeries", "byNumberOfPatientSurgeries");
    }
  }, [data, getDataNumberOf]);

  return (
    <>
      {isLoading && <LoadingData />}
      {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
      {data && (
        <div className="card shadow-lg h-100">
          <div className="card-body">
            <div className="d-flex flex-row-reverse justify-content-center flex-wrap gap-2">
              <div
                className="d-flex align-items-center justify-content-center bg-secondary rounded-1 text-white align-self-center"
                style={{
                  width: "40px",
                  height: "40px",
                }}
              >
                <BsFileEarmarkSpreadsheet className="icon" />
              </div>

              <div className="vstacks flex-fill gap-3">
                <h4 className="mb-0">{data}</h4>
                <p className="mb-0">No. procedimientos</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
